import { isFunction, isArray, hasKey } from '@bayer-int/portletce-shared';
import { createSelector } from 'reselect';

// eslint-disable-next-line
type UnknownSelector = (s: any) => unknown;

/**
 * Function that clones store selector in such a manner, that if the selector is memoized
 * via `reselect`, it will return another cached selector.
 *
 * Useful in scenarios when we use the same selector on different states - which would
 * invalidate cached everytime
 */
export function cloneSelector<S extends UnknownSelector>(selector: S): S {
    return cloneReselectSelector(selector) || selector;
}

function cloneReselectSelector<S extends UnknownSelector>(selector: S): S | null {
    return hasKey(selector, 'resultFunc') &&
        isFunction(selector.resultFunc) &&
        hasKey(selector, 'dependencies') &&
        isArray(selector.dependencies) &&
        selector.dependencies.every(isFunction)
        ? (createSelector(
              ...(selector.dependencies as [UnknownSelector]),
              selector.resultFunc,
          ) as unknown as S)
        : null;
}
